import React from "react";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

interface ExcelFileProps {
  file: { fileUrl: string; fileName: string } | null;
  onChange: (file: null) => void;
}

export default function ExcelFileViewer({ file, onChange }: ExcelFileProps) {
  const handleDelete = () => {
    onChange(null);
  };

  if (!file) return null;

  return (
    <div
      style={{
        width: "300px",
        height: "150px",
        border: "1px solid #ddd",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <a href={file.fileUrl} target="_blank" rel="noopener noreferrer">
          <InsertDriveFileOutlinedIcon
            style={{ fontSize: "70px", color: "#1565C0" }}
          />
        </a>
      </div>

      <div
        style={{
          backgroundColor: "#1565C0",
          padding: "6px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: "#fff",
          fontSize: "14px",
        }}
      >
        <span
          style={{
            marginLeft: "10px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            textAlign: "right",
          }}
        >
          {file.fileName}
        </span>
        <span style={{ textAlign: "end" }}>
          <DeleteOutlineOutlinedIcon
            style={{ cursor: "pointer" }}
            onClick={handleDelete}
          />
        </span>
      </div>
    </div>
  );
}
